import { auth as authEndpoints } from 'admin/resources';

export const SSO_ORGANIZATION_SLUG_KEY = 'ssoOrganizationSlug';

export type OrganizationLoginDiscovery =
	| { exists: false; login: null }
	| { exists: true; login: { ssoEnabled: boolean; passwordAllowed: boolean } };

export type StartOrganizationSSOResponse = {
	url: string;
};

export type CompleteOrganizationSSOResponse = {
	linked: boolean;
	emailMismatch: boolean;
	redirectTo?: string;
};

export const getOrganizationLoginDiscovery = async (organizationSlug: string) => {
	const response: ApiV2Response<OrganizationLoginDiscovery> = await authEndpoints.get.organization
		.params({ organizationSlug })
		.send({});

	return response.body;
};

export const startOrganizationSSO = async (organizationSlug: string) => {
	const response: ApiV2Response<StartOrganizationSSOResponse> = await authEndpoints.get.sso
		.params({ organizationSlug })
		.send({});

	return response.body;
};

export const completeOrganizationSSO = async (params: { organizationSlug: string; code: string; state: string }) => {
	const { organizationSlug, code, state } = params;
	const response: ApiV2Response<CompleteOrganizationSSOResponse> = await authEndpoints.get.ssoCallback
		.params({ organizationSlug })
		.send({ code, state });

	return response.body;
};
